import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import CardLayout from "../../components/Layout/CardLayout";
import PathConstants from "../../routes/pathConstants";
import PropTypes from "prop-types";

const flowActions = {
  printedTicket: (navigate) => {
    navigate(`${PathConstants.CONTACT_INFO}?type=activate`);
  },
  payNow: (navigate) => {
    navigate(`${PathConstants.CONTACT_INFO}?type=purchase`);
  },
};

const getFlowAction = (flow, navigate) => {
  const action = flowActions[flow];
  if (!action) return () => {};
  return () => action(navigate);
};

const WelcomeConfigCards = ({ welcomeConfig }) => {
  const navigate = useNavigate();

  return (
    <CardLayout>
      {welcomeConfig.map((section, sectionIndex) => (
        <div key={sectionIndex}>
          {sectionIndex > 0 && (
            <div className="dividerDark">
              <div
                className="border-neutral-light"
                style={{ margin: "1rem 1rem", fontWeight: 700 }}
              >
                or
              </div>
            </div>
          )}
          {section.header && (
            <h2
              style={{
                color: "var(--secondary-color)",
                fontWeight: 700,
                fontSize: "20px",
                marginBottom: ".5rem",
              }}
            >
              {section.header}
            </h2>
          )}
          {section.body && (
            <p style={{ marginBottom: ".5rem" }}>{section.body}</p>
          )}
          {section.actions.map((action, actionIndex) => (
            <Button
              key={actionIndex}
              size="large"
              variant="contained"
              onClick={getFlowAction(action.flow, navigate)}
              color="primary"
              style={{
                fontWeight: 700,
                width: "100%",
                height: "3rem",
                marginTop: "1rem",
              }}
            >
              {action.copy}
            </Button>
          ))}
        </div>
      ))}
    </CardLayout>
  );
};

WelcomeConfigCards.propTypes = {
  welcomeConfig: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      body: PropTypes.string,
      actions: PropTypes.arrayOf(
        PropTypes.shape({
          flow: PropTypes.oneOf(["printedTicket", "payNow"]).isRequired,
          copy: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
};

export default WelcomeConfigCards;
